export default __webpack_public_path__ + "static/media/in_progress_desktop.e17972d7.svg";